import LandingPage from "./pages/LandingPage";
import ReservationCancelledPage from "./pages/ReservationCancelledPage";
import ReservationSuccessPage from "./pages/ReservationSuccessPage";
import ThankYouPage from "./pages/ThankYouPage";

export default function App() {
  const path = window.location.pathname.replace(/\/$/, "");

  if (window.fbq) {
    window.fbq('track', 'PageView-' + path);
  }

  if (path === "/thank-you") {
    return <ThankYouPage />;
  }

  if (path === "/reservation-success") {
    return <ReservationSuccessPage />;
  }

  if (path === "/reservation-cancelled") {
    return <ReservationCancelledPage />;
  }

  return <LandingPage />;
}
